<template>
  <div class="header">
    <div class="header-yy">
      <div class="container">
            <!-- logo -->
        <div class="logo">
          <!-- <img src="../assets/logo.png" alt="logo"> -->
          </div>
   
          <div class="header-login-box">
               <!-- 注册/登录 -->
          <div class="login" @click="login" v-if="!isLogIn">
            <span>注册/登录</span>
          </div>
          <!-- 修改密码 -->

          <div class="user-name" v-else>
            <span>{{ username }}</span>
            <div class="user-submenu">
              <div class="user-submenu-item" @click="changePassword">修改密码</div>
              <div class="user-submenu-item" @click="logOut">退出登录</div>
            </div>
          </div>
          <!--申请试用 -->
          <div class="apply" @click="applyTrial">
            <span>申请试用</span>
          </div>
          </div>
       
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: ['username', 'isLogIn'],
  methods: {
    login() {
      this.$emit('login')
    },
    applyTrial() {
      this.$emit('apply-trial')
    },
    logOut() {
      this.$emit('logout')
    },
    changePassword() {
      this.$emit('change-password')
    },
    toContent() {
      window.scroll({
        top: document.querySelector(".content-security").getBoundingClientRect().top,
        behavior: 'smooth'
      });
    },
    toMoXing() {
      window.scroll({
        top: document.querySelector(".model").getBoundingClientRect().top,
        behavior: 'smooth'
      });
    },
    toChanye() {
      window.scroll({
        top: document.querySelector(".product").getBoundingClientRect().top,
        behavior: 'smooth'
      });
    },
    toHangye() {
      window.scroll({
        top: document.querySelector(".industry").getBoundingClientRect().top,
        behavior: 'smooth'
      });
    },
    toAbout() {
      window.scroll({
        top: document.querySelector(".about").getBoundingClientRect().top,
        behavior: 'smooth'
      });
    },
  }
}
</script>

<style scoped lang="scss">
.header{
  width: 100%;
  min-width: 1408px;
  height: 145px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    background: linear-gradient(180deg
, #023273 0%,rgba(0,0,0,0) 100%);
.header-login-box{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
}
.header-yy {
  width: 100%;
  height: 80px;
  // border-bottom: 1px solid #FFFFFF;
  .container{
    width: 1180px;
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
  }
  .logo{
    width: 250px;
    height: 28px;
    // cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .nav {
    ul {
      display: flex;
        li {
          font-size: 19px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          cursor: pointer;
          padding: 0 24px;
          position: relative;
          height: 80px;
          line-height: 80px;
          .nav-content{
            width: 182px;
            background:rgba(2, 50, 115, 0.6);
            border-radius: 0px 0px 8px 8px;
            text-align: center;
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 70px;
            padding: 15px 0;
            position: absolute;
            left: -40px;
            top: 80px;
            display: none;
            z-index: 20;
            .nav-content-item-text{
              height: 70px;
              position: relative;
            }
            .nav-content-item-text::after{
              content: '';
              display: block;
              width: 0;
              height: 4px;
              background: linear-gradient(90deg, rgba(0,0,0,0) 0%,rgba(255,255,255,0.97) 51% ,rgba(0,0,0,0) 100%);
              transition: width 0.3s;
              position: absolute;
              bottom: 0px;
              left:0;
            }
            .nav-content-item-text:hover::after {
              width: 100%;
            }
          }
        }
        // hover
        li:hover {
          .nav-content{
            display: block;
          }
        }
        li::after {
          content: '';
          display: block;
          width: 0;
          height: 4px;
          background: linear-gradient(90deg, rgba(0,0,0,0) 0%,rgba(255,255,255,0.97) 51% ,rgba(0,0,0,0) 100%);
          transition: width 0.3s;
          position: absolute;
          bottom: 0px;
          left:0;
        }
        li:hover::after {
          width: 100%;
        }
      }
    }
    .login{
      height: 30px;
      border: 1px solid #FFFFFF;
      border-radius: 4px;
      cursor: pointer;
      margin-right: 20px;
   
      span {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        padding: 7px 14px;
      }
    }
    .apply{
      height: 30px;
      border: 1px solid #FFFFFF;
      border-radius: 4px;
      cursor: pointer;

      span {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        padding: 7px 14px;
      }
    }
    .user-name {
      font-size: 19px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      cursor: pointer;
      padding: 0 24px;
      position: relative;
      max-width: 200px;
      height: 80px;
      line-height: 80px;
      &::before {
        position: absolute;
        display: block;
        top: 33px;
        left: 5px;
        content: " ";
        width: 12px;
        height: 14px;
        background: url('../assets/icon-username.png') center center / contain no-repeat;
      }
      span {
        display: block;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .user-submenu {
        display: none;
        position: absolute;
        left: -40px;
        top: 80px;
        background-color: rgba(2, 50, 115, .7);
        border-radius: 0px 0px 8px 8px;
        text-align: center;
      }
      .user-submenu-item {
        position: relative;
        height: 70px;
        &::after {
          content: '';
          display: block;
          width: 0;
          height: 4px;
          background: -webkit-gradient(linear, left top, right top, from(rgba(0,0,0,0)), color-stop(51%, rgba(255,255,255,0.97)), to(rgba(0,0,0,0)));
          background: linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(255,255,255,0.97) 51%, rgba(0,0,0,0) 100%);
          -webkit-transition: width 0.3s;
          transition: width 0.3s;
          position: absolute;
          bottom: 0px;
          left: 0;
        }
        &:hover::after {
          width: 100%;
        }
      }
      &:hover {
        .user-submenu {
          display: block;
          width: 182px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Header.vue